import * as React from 'react';
import { Input, InputGroup, InputLeftElement, InputRightElement } from '@chakra-ui/core';
import { Keyboard } from '../keyboard';

type TextInputProps = any & {
    leftElement?: any;
    rightElement?: any;
};

const TextInput: React.FC<TextInputProps> = (
    React.forwardRef(({
        leftElement,
        rightElement,
        ...rest
    }: any, ref: React.ElementRef<any>) => (
        <Keyboard>
            <InputGroup>
                {leftElement && <InputLeftElement>{leftElement}</InputLeftElement>}
                <Input focusBorderColor="brand.green.base" bg="transparent" {...rest} />
                {rightElement && <InputRightElement>{rightElement}</InputRightElement>}
            </InputGroup>
        </Keyboard>
    ))
);

export default TextInput;
